export default __webpack_public_path__ + "static/media/date.94a7803c.svg";